import React from 'react'

import { ExposeCoordinatesView } from 'common/builder/components/chart/FlowChart/components/ExposeCoordinatesView/ExposeCoordinatesView'
import { useBlockContainerName } from 'common/builder/components/chart/FlowChart/hooks/useBlockContainerName'

interface InteractiveBlockContainerProps {
  id: string
  children: React.ReactNode
  style?: React.CSSProperties
  /**
   * Exposes block to app.js so then block coordinates could be retrieven
   */
  exposeBlockCoordinates?: boolean
}

export const InteractiveBlockContainer = ({
  id,
  style,
  exposeBlockCoordinates,
  children,
}: InteractiveBlockContainerProps) => {
  const blockName = useBlockContainerName(id)

  const Component = exposeBlockCoordinates ? ExposeCoordinatesView : 'view'

  return (
    <Component
      name={blockName}
      id={id}
      // @ts-expect-error conflict with types from lib.dom.d.ts.SVGViewElement
      interactive
      style={{ display: 'flex', flexDirection: 'column', ...style }}
    >
      {children}
    </Component>
  )
}
